// translations/pages/events/en.js
// Labels of the events section and page, and the texts of every event by its id
// from config/events.cjs. Dates are not written here; the pages format them.

export const eventsPageEN = {
  title: 'Events',
  upcoming: 'Upcoming events',
  past: 'Past events',
  all: 'All events',
  items: {
    wikki26: {
      title: 'WiKKI26 – Wildau Conference on Artificial Intelligence',
      description: 'pAIoneer Labs exhibited at the Technical University of Applied Sciences Wildau. The stand was about how local AI infrastructure is built in companies and organisations: data sovereignty, data protection by design and legally compliant AI, without unnecessary dependence on external cloud solutions.'
    }
  }
};
